import { defineStore } from 'pinia';

interface ScoreValue {
  status: string;
  step: number;
}
const useScoreStore = defineStore("score", {
  state: () => ({
    score: [] as ScoreValue[],
  }),

  getters: {
    successCount: (state) =>
      state.score.filter((s) => s.status === "success").length,
    failureCount: (state) =>
      state.score.filter((s) => s.status === "error").length,
  },

  actions: {
    async setScore(status: string, step: number) {
      const newValue: ScoreValue = { status, step };
      this.score.push(newValue);
    },

    hasSuccess(step: number): boolean {
      const item = this.score.find((s) => s.step === step);
      return item?.status === "success" ?? false;
    },

    hasError(step: number): boolean {
      const item = this.score.find((s) => s.step === step);
      return item?.status === "error" ?? false;
    },

    reset() {
      this.score = [];
    },
  },
});

export default useScoreStore
